import React from 'react'
import {Switch, Route, Redirect, withRouter, RouteComponentProps} from 'react-router-dom'
import UserView from 'views/User'
import services from 'services'
import ProjectView from './Project'
import User from 'views/User'
import Sandbox from './Sandbox'

function AppContent(props: RouteComponentProps) {
  services.router.initialize(props)
  return (
    <Switch>
      <Route exact path="/" component={() => <Redirect to="/projects" />} />
      <Route path="/user" component={UserView} />
      <Route path="/projects" component={ProjectView} />
      <Route path="/user" component={User} />

      <Route path="/sandbox" component={Sandbox} />
    </Switch>
  )
}

export default withRouter(AppContent)
